export var FUSION_UI_VIEW_PREFIX = 'CnLayout-layout-view';
export var PAGE = 'CnLayoutPage';
export var PAGE_HEADER = 'CnLayoutHeader';
export var PAGE_FOOTER = 'CnLayoutFooter';
export var PAGE_NAV = 'CnLayoutNav';
export var PAGE_ASIDE = 'CnLayoutAside';
export var PAGE_CONTENT = 'CnLayoutContent';
export var SECTION = 'CnLayoutSection';
export var BLOCK = 'CnLayoutBlock';
export var TILE = 'CnTile';
export var CELL = 'CnLayoutCell';
export var ROW = 'CnLayoutRow';
export var COL = 'CnLayoutCol';
export var GRID = 'CnLayoutGrid';
export var P = 'CnLayoutP';
export var FIXED_POINT = 'CnLayoutFixedPoint';
export var FIXED_CONTAINER = 'CnLayoutFixedContainer';